/**
 * @generated SignedSource<<766b29e8a15cb4e905187ec824e6a02f>>
 * @relayHash 8ab5118879d3d1b7d9f5bd2a2ad414fb
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8ab5118879d3d1b7d9f5bd2a2ad414fb

import { ConcreteRequest } from 'relay-runtime';
export type Language = "ENGLISH" | "FRENCH" | "GERMAN" | "ITALIAN";
export type SteeringLevelValue = "FOUR" | "MINUS_ONE" | "ONE" | "THREE" | "TWO" | "ZERO";
export type useSteeringLevelsSubscription$variables = Record<PropertyKey, never>;
export type useSteeringLevelsSubscription$data = {
  readonly steeringLevelsChanged: ReadonlyArray<{
    readonly id: string;
    readonly isAutomatic: boolean;
    readonly language: Language;
    readonly level: SteeringLevelValue;
    readonly levelValue: number;
  }>;
};
export type useSteeringLevelsSubscription = {
  response: useSteeringLevelsSubscription$data;
  variables: useSteeringLevelsSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "SteeringLevel",
    "kind": "LinkedField",
    "name": "steeringLevelsChanged",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "level",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "language",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "levelValue",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isAutomatic",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "useSteeringLevelsSubscription",
    "selections": (v0/*:: as any*/),
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useSteeringLevelsSubscription",
    "selections": (v0/*:: as any*/)
  },
  "params": {
    "id": "8ab5118879d3d1b7d9f5bd2a2ad414fb",
    "metadata": {},
    "name": "useSteeringLevelsSubscription",
    "operationKind": "subscription",
    "text": null
  }
};
})();

(node as any).hash = "0d7904f7e54efbb99980b79d431f1214";

export default node;
